import { json } from 'd3'

import { IBarrierTypeIcon, IPaginatedREST } from '../types'
import { BOWTIE_BARRIER_TYPE_ICONS, BOWTIE_BASE_URL } from '../utils/constants'

export interface IBarrierTypeIconFilters {
    direction?: 'ASC' | 'DESC'
    orderBy?: string
}

export const listBarrierTypeIcons = async (
    params?: IBarrierTypeIconFilters
): Promise<IPaginatedREST<IBarrierTypeIcon>> => {
    const qs = new URLSearchParams({
        direction: params?.direction ?? 'ASC',
        orderBy: (params?.orderBy ?? 'ID').toUpperCase()
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_BARRIER_TYPE_ICONS}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return { ...jsonData, data: jsonData.data.sort((a, b) => a.id - b.id) }
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}

export const updateBarrierTypeIcon = async (body: IBarrierTypeIcon): Promise<IBarrierTypeIcon> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_BARRIER_TYPE_ICONS}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}
